<!--
 * @message: order 分页
 * @Author: cjc
 * @since: 2019-11-26 15:36:36
 * @lastTime     : 2020-01-06 14:46:23
 * @LastAuthor   : cjc
 -->
<template>
  <div id="order">
    <div class="header">
      <div class="logo">
        <img src="@/assets/images/logo.png" alt="延禧秘传" />
      </div>
      <menu-comp></menu-comp>
    </div>
    <div class="container">
      <div class="role">
        <img src="@/assets/images/role.png" />
      </div>
      <div class="order-step">
        <img class="slogan" src="@/assets/images/slogan.png" />
        <form action @submit.prevent="onSubmit">
          <div class="step-block">
            <div class="fb-like step1" data-href="https://www.facebook.com/%E5%BB%B6%E7%A6%A7%E7%A7%98%E4%BC%A0-103162351155987/" data-layout="button" data-action="like" data-size="large" data-share="false"></div>
            <input-item class="step2" @input="getNumber"></input-item>
          </div>
          <div class="btn-block">
            <button class="btn order" type="submit"></button>
            <a class="btn order_gift" @click="handlerGift"></a>
          </div>
        </form>
      </div>
    </div>
    <div v-if="isShowGift" class="gift-box" >
      <button class="btn closed" @click="handlerGift"></button>
      <a class="btn order_tips" @click="isShowTips = true"></a>
    </div>
    <div v-if="isShowTips" class="gift-tips">
      <h3>注意事项</h3>
      <p>①《延禧秘传》于开服前，将通过手机短讯的方式发送预约礼包奖励和开服通知；</p>
      <p>②每个礼包兑换码只能被使用一次，一个游戏账号只能兑换此类礼包兑换码一次，逾期无效；</p>
      <p>③如因提供的资料不完整、不正确、冒用他人资料等，均视为无条件放弃奖励；</p>
      <p>④若有疑问，请咨询Facebook官方粉丝团在线客服；</p>
      <p>⑤本活动最终解释权归《延禧秘传》营运团队所有。</p>
      <button class="closed" @click="isShowTips = false">×</button>
    </div>
  </div>
</template>

<script>
import imputComp from '@/components/input'
import menuComp from '@/components/menu'

export default {
  name: 'order-section',
  data () {
    return {
      formData: {
        country: null,
        nation_code: null,
        number: null
      },
      isShowGift: false,
      isShowTips: false
    }
  },
  mounted () {
    // let roleContaienr = this.$el.querySelector('.role')
    // let animTop = document.createElement('div')
    // roleContaienr.appendChild(animTop)
  },
  methods: {
    onSubmit () {
      let reg = null
      let country = this.formData.country
      let nationCode = this.formData.nation_code
      let number = this.formData.number
      if (country && number) {
        switch (country) {
          case '新加坡':
            reg = /^[89][0-9]{7}$/
            break
          case '马来西亚':
            reg = /^[1][0-9]{8,9}$/
            break
          case '其他':
            reg = /^[1][0-9]{7,10}$/
            break
          default:
            break
        }
        if (!reg.test(number)) {
          alert('请输入正确手机号码')
          return null
        }
      } else {
        alert('请填写您的手机号码')
        return null
      }
      if (!nationCode) {
        alert('请填写正确的国际电话区号')
        return null
      }

      // eslint-disable-next-line no-undef
      fbq('track', 'CompleteRegistration') // facebook 像素处理

      let id = '5dfc25bf87192a7c1cb340f6' // 后台提交地址id
      this.$http
        // 正式地址：http://gongting.hkleyougame.com/
        .get('/activity/' + id, {
          params: {
            action: 'appointment_mobile',
            area: country,
            mobile: nationCode + '-' + number
          }
        })
        .then(function (response) {
          let status = response.data.code
          let msg = ''
          // switch (status) {
          //   case 0:
          //     let mobile = response.data.cont.mobile.replace('-', ' ')
          //     msg = `预约成功，请再次确认您的预约号码+${mobile}正确填写`
          //     break
          //   case -2:
          //     msg = '您已成功预约，请勿重复操作'
          //     break
          //   default:
          //     msg = response.data.msg
          //     break
          // }
          status > -1 && (msg = '活动已结束')
          alert(msg)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getNumber (data) {
      this.formData.country = data.name
      this.formData.nation_code = data.areaCode
      this.formData.number = data.number
    },
    handlerGift () {
      // eslint-disable-next-line no-undef
      !this.isShowGift && fbq('track', 'Lead') // facebook 像素处理

      this.isShowGift = !this.isShowGift
    },
    setAnimation (target, png, json) {

    }
  },
  components: {
    [imputComp.name]: imputComp,
    [menuComp.name]: menuComp
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/orderSection.scss';
</style>



// WEBPACK FOOTER //
// src/views/section/order.vue